// Question and answer map. Spec tab 05. Labels may be reworded; values must not change.
// tag = Attentive data value (same as the Digioh quiz). Only Q2 and Q3 sync to Attentive.
var TLB_QUESTIONS = [
  {
    id: 'Q1', step: 'Lips feeling', layout: 'text', cols: 2,
    title: 'How do you want your lips to make you feel?',
    options: [
      { value: 'BOLD', label: 'Bold' },
      { value: 'POLISHED', label: 'Polished' },
      { value: 'SOFT', label: 'Soft' },
      { value: 'PLAYFUL', label: 'Playful' }
    ]
  },
  {
    id: 'Q2', step: 'Fave color', layout: 'image', cols: 4,
    title: 'Which colors are you reaching for?',
    options: [
      { value: 'RED', label: 'Reds', tag: 'reds', image: 'tlb-quiz-color-reds.webp' },
      { value: 'PINK_MAUVE', label: 'Pinks & Mauves', tag: 'pinks', image: 'tlb-quiz-color-pinks-mauves.webp?v=2' },
      { value: 'BERRY_PLUM', label: 'Berries & Plums', tag: 'plums', image: 'tlb-quiz-color-berries-plums.webp' },
      { value: 'NUDE_NEUTRAL', label: 'Nudes & Neutrals', tag: 'nudes', image: 'tlb-quiz-color-nudes-neutrals.webp' }
    ]
  },
  {
    id: 'Q3', step: 'Preference', layout: 'text', cols: 1,
    title: 'What matters most when you put it on?',
    options: [
      { value: 'LONG_LASTING', label: 'Long Lasting Color', tag: 'color' },
      { value: 'COMFY_CUTE', label: 'Comfy but Cute', tag: 'comfy' },
      { value: 'SUPER_MOISTURIZING', label: 'Super Moisturizing', tag: 'moisture' }
    ]
  },
  {
    id: 'Q4', step: 'Lip product', layout: 'icon', cols: 4,
    title: 'What stops you from loving a lip product?',
    options: [
      { value: 'COLOR_LOOKS_DIFFERENT', label: 'Color looks different', image: 'tlb-quiz-icon-color-different.svg' },
      { value: 'TOO_DRYING', label: 'Too drying', image: 'tlb-quiz-icon-too-drying.svg' },
      { value: 'DOES_NOT_LAST', label: 'Doesn\u2019t last', image: 'tlb-quiz-icon-doesnt-last.svg' },
      { value: 'STICKY_HEAVY', label: 'Feels sticky / heavy', image: 'tlb-quiz-icon-sticky-heavy.svg' }
    ]
  },
  {
    id: 'Q5', step: 'Complexion', layout: 'image', cols: 3,
    title: 'What\u2019s your complexion range?',
    options: [
      { value: 'FAIR', label: 'Fair', image: 'tlb-quiz-complexion-fair.webp' },
      { value: 'LIGHT', label: 'Light', image: 'tlb-quiz-complexion-light.webp' },
      { value: 'MEDIUM', label: 'Medium', image: 'tlb-quiz-complexion-medium.webp' },
      { value: 'MEDIUM_DEEP', label: 'Medium Deep', image: 'tlb-quiz-complexion-medium-deep.webp' },
      { value: 'DEEP', label: 'Dark', image: 'tlb-quiz-complexion-dark.webp' },
      { value: 'DEEP_DARK', label: 'Deep Dark', image: 'tlb-quiz-complexion-deep-dark.webp' }
    ]
  },
  {
    id: 'Q6', step: 'Undertone', layout: 'wide-image', cols: 3,
    title: 'Gold or silver?',
    subtitle: 'Whichever looks best on you - that\u2019s your undertone talking.',
    footnote: 'Still not sure? Green-ish veins say gold, blue say silver - and \u2018both\u2019 is never wrong.',
    options: [
      { value: 'WARM', label: 'Warm', image: 'tlb-quiz-undertone-warm.webp' },
      { value: 'NEUTRAL', label: 'Neutral', image: 'tlb-quiz-undertone-neutral.webp' },
      { value: 'COOL', label: 'Cool', image: 'tlb-quiz-undertone-cool.webp' }
    ]
  },
  {
    id: 'Q7', step: 'Frequency', layout: 'icon', cols: 4,
    title: 'When do you wear lip color?',
    options: [
      { value: 'DAILY', label: 'Daily, no matter what', image: 'tlb-quiz-icon-daily.svg' },
      { value: 'WORK', label: 'Work or meetings', image: 'tlb-quiz-icon-work.svg' },
      { value: 'EVENTS', label: 'Nights out / events', image: 'tlb-quiz-icon-nights-out.svg' },
      { value: 'MOOD', label: 'Only when I\u2019m in the mood', image: 'tlb-quiz-icon-dress-up.svg' }
    ]
  }
];

if (typeof module !== 'undefined') module.exports = TLB_QUESTIONS;
